import { svg } from "config/svgStyles";

export const reviewImages = {
  position: "relative",
};

export const imageContainer = ({ isMobile }) => ({
  position: "relative",

  height: isMobile ? "195px" : "300px",

  "> div": {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50% 50%",
    backgroundSize: "auto 100%",
  },
});

export const nextButton = ({ isMobile }) => ({
  background: "text",
  color: "background",
  ...svg("background"),
  cursor: "pointer",
  position: "absolute",
  top: "50%",
  right: 0,
  width: isMobile ? "40px" : "60px",
  height: isMobile ? "40px" : "100px",
  mt: "-20px",
  borderRadius: "20px 0px 0px 20px",
  zIndex: "2000",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",

  svg: {
    width: isMobile ? "8px" : "12px",
    height: isMobile ? "16px" : "24px",
  },
});

export const previousButton = ({ isMobile }) => ({
  ...nextButton({ isMobile }),
  left: 0,
  right: "auto",
  borderRadius: "0 20px 20px 0",
});
